<div class="row m-0 justify-content-center" style="padding-top: 25px;" *ngIf="isCheckIn && dato">
  <div class="col-12 pt-2 pr-0 container-items pl-0 m-0 align-items-stretch">
    <div class="d-flex container-item-card justify-content-between" style="border: 2px solid #c2c2c3; border-radius: 8px; gap: 25px;">
      <!-- Icon column -->
      <div class="d-flex align-items-center justify-content-center" style="width: 100%; max-width: 175px; background-color: #f1f1f1; border-top-left-radius: 6px; border-bottom-left-radius: 6px;">
        <img
          style="width: 60px; height: 60px; object-fit: contain;"
          src="../../../../assets/img/app/categories-search-box/AEREO.svg"
          alt="Vuelo"
        />
      </div>

      <div class="hotel-item-description px-0" style="width: calc(100% - 190px); padding-bottom: 10px;">
        <div class="d-flex- flex-column">
          <div class="d-flex justify-content-between align-items-start mb-3">
            <div class="mt-2" style="min-height: 48px;">
              <p
                class="tittle mb-1"
                style="max-width: 320px; font-family: &quot;Poppins&quot;; font-size: 18.5px; font-weight: 600; line-height: 1.3; margin-top: 5px !important"
              >
                {{ dato.title }} <span *ngIf="isRoundTrip()" style="font-size: 14px; font-weight: 400; color: #666;">(ida y vuelta)</span>
                <span
                  *ngIf="getDirectionChipText()"
                  class="px-2 py-1 ml-1"
                  [ngStyle]="{
                    'font-size': '12px',
                    'font-family': 'Rubik',
                    'border-radius': '6px',
                    'font-weight': dato.direction === 'VUELTA' ? 500 : 700,
                    'color': dato.direction === 'VUELTA' ? '#ffffff' : '#333333',
                    'background-color': dato.direction === 'VUELTA' ? '#ed3b5b' : '#ffffff',
                    'border': dato.direction === 'VUELTA' ? 'none' : '1px solid #d0d0d0'
                  }"
                >{{ getDirectionChipText() }}</span>
              </p>
              <span *ngIf="dato.rateClassId === 'R'" class="px-2 py-1" style="font-size: 12px; font-family: 'Rubik'; font-weight: 400; color: #34c26d; background-color: #defef4; border-radius: 6px;">Reembolsable</span>
              <span *ngIf="dato.rateClassId && dato.rateClassId !== 'R'" class="px-2 py-1" style="font-size: 12px; font-family: 'Rubik'; font-weight: 400; color: #ed3b5b; background-color: #fde6ea; border-radius: 6px;">No Reembolsable</span>
            </div>
            <div class="d-flex">
              <div class="pt-2 pr-2" style="font-weight: 400;">
                <span *ngIf="dato.status_id === 1" class="status status-sidebar product-status-saved">{{ dato.status }}</span>
                <span *ngIf="dato.status_id === 2" class="status status-sidebar product-status-reserved">{{ dato.status }}</span>
                <span *ngIf="dato.status_id === 3" class="status status-sidebar product-status-locked">{{ dato.status }}</span>
                <span *ngIf="dato.status_id === 4" class="status status-sidebar product-status-denied">{{ dato.status }}</span>
                <span *ngIf="dato.status_id === 5" class="status status-sidebar product-status-cancelled">{{ dato.status }}</span>
                <span *ngIf="dato.status_id === 6" class="status status-sidebar product-status-paid-agency">{{ dato.status }}</span>
                <span *ngIf="dato.status_id === 7" class="status status-sidebar product-status-paid-provider">{{ dato.status }}</span>
                <span *ngIf="dato.status_id === 8" class="status status-sidebar product-status-completed">{{ dato.status }}</span>
              </div>
              <div
                *ngIf="dato.status_id !== 5"
                class="d-flex align-items-end justify-content-center"
                style="border-bottom: 1px solid #ccc; border-left: 1px solid #ccc; border-bottom-left-radius: 6px; padding: 10px 15px; gap: 5px;"
              >
                <div style="width: 25px; height: 25px" *ngIf="dato.status_id === 1">
                  <img
                    style="margin-top: -4px; cursor: pointer"
                    tooltip="Eliminar producto"
                    (click)="removeItem(dato)"
                    placement="bottom"
                    src="../../../../assets/icons/summary/delete.svg"
                    alt=""
                  />
                </div>

                <div style="width: 25px; height: 25px" *ngIf="dato.status_id === 2">
                  <img
                    style="
                      margin-top: -4px;
                      cursor: pointer;
                      filter: invert(16%) sepia(99%) saturate(7493%) hue-rotate(1deg) brightness(95%) contrast(119%);
                    "
                    tooltip="Cancelar producto"
                    (click)="removeItem(dato)"
                    placement="bottom"
                    src="../../../../assets/icons/itinerary-detail/04-01.svg"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="d-flex justify-content-between align-items-stretch">
          <!-- ============ COL 1: Ruta (Origen / Destino + Tipo) ============ -->
          <div class="d-flex flex-column pt-3 pr-2" style="width: 32%; min-height: 62px;">
            <!-- Origen -->
            <div class="d-flex align-items-start mb-2">
              <img width="18px" height="18px" style="margin-top: 2px; margin-right: 6px;"
                   src="../../../../assets/icons/itinerary/lugar.svg" alt="" />
              <div class="d-flex flex-column">
                <p class="mb-0"
                   style="font-family: 'Rubik', serif !important; font-size: 13px; font-weight: 600; line-height: 1.2; color: #333;">
                  Origen: <span style="font-weight: 700;">{{ getFirstSegment()?.departure?.airport ?? dato.origin }}</span>
                </p>
                <p class="mb-0 mt-1"
                   style="font-family: 'Rubik', serif !important; font-size: 12px; font-weight: 500; line-height: 1.2; color: #666;">
                  {{ formatDate(getFirstSegment()?.departure?.dateTime ?? dato.arrivalDate) }}
                  &nbsp;|&nbsp; {{ formatTime(getFirstSegment()?.departure?.dateTime) }}
                </p>
              </div>
            </div>

            <!-- Destino -->
            <div class="d-flex align-items-start mb-2">
              <img width="18px" height="18px" style="margin-top: 2px; margin-right: 6px;"
                   src="../../../../assets/icons/itinerary/lugar.svg" alt="" />
              <div class="d-flex flex-column">
                <p class="mb-0"
                   style="font-family: 'Rubik', serif !important; font-size: 13px; font-weight: 600; line-height: 1.2; color: #333;">
                  Destino: <span style="font-weight: 700;">{{ getFirstSegment()?.arrival?.airport ?? dato.destinationAirport }}</span>
                </p>
                <p class="mb-0 mt-1"
                   style="font-family: 'Rubik', serif !important; font-size: 12px; font-weight: 500; line-height: 1.2; color: #666;">
                  {{ formatDate(getFirstSegment()?.arrival?.dateTime ?? dato.departureDate) }}
                  &nbsp;|&nbsp; {{ formatTime(getFirstSegment()?.arrival?.dateTime) }}
                </p>
              </div>
            </div>

            <!-- Tipo -->
            <p class="mb-0 mt-1"
               style="font-family: 'Rubik', serif !important; font-size: 12px; font-weight: 600; line-height: 1.2; color: #34c26d;">
              {{ getFlightType() }}
            </p>
          </div>

          <!-- Line Vertical -->
          <div style="width: 1px; background-color: #ccc;"></div>

          <!-- ============ COL 2: Vuelo (Nro + Tiempo) ============ -->
          <div class="d-flex flex-column justify-content-start pt-3 px-2" style="width: 24%;">
            <p class="mb-1"
               style="font-family: 'Rubik', serif !important; font-size: 12px; font-weight: 500; line-height: 1.2; color: #666;">
              Número de vuelo:
            </p>
            <p class="mb-2"
               style="font-family: 'Rubik', serif !important; font-size: 13px; font-weight: 700; line-height: 1.2; color: #000;">
              {{ getFirstSegment()?.airline?.code }} {{ getFirstSegment()?.flightNumber }}
            </p>

            <p class="mb-1"
               style="font-family: 'Rubik', serif !important; font-size: 12px; font-weight: 500; line-height: 1.2; color: #666;">
              Tiempo de vuelo:
            </p>
            <p class="mb-0"
               style="font-family: 'Rubik', serif !important; font-size: 13px; font-weight: 700; line-height: 1.2; color: #000;">
              {{ formatDuration(getSelectedOption()?.duration) }}
            </p>
          </div>

          <!-- Line Vertical -->
          <div style="width: 1px; background-color: #ccc;"></div>

          <!-- ============ COL 3: Pasajeros + Cabina ============ -->
          <div class="d-flex flex-column justify-content-start pt-3 px-2" style="width: 20%;">
            <p class="mb-0"
               style="font-family: 'Rubik', serif !important; font-size: 13px; font-weight: 600; line-height: 1.3; color: #000;">
              {{ dato.adults }} {{ dato.adults === 1 ? 'Adulto' : 'Adultos' }}
            </p>
            <p class="mb-2"
               style="font-family: 'Rubik', serif !important; font-size: 13px; font-weight: 600; line-height: 1.3; color: #000;">
              {{ dato.children }} {{ dato.children === 1 ? 'Niño' : 'Niños' }}
            </p>

            <p class="mb-1 mt-2"
               style="font-family: 'Rubik', serif !important; font-size: 12px; font-weight: 500; line-height: 1.2; color: #666;">
              Cabina:
            </p>
            <p class="mb-0"
               style="font-family: 'Rubik', serif !important; font-size: 13px; font-weight: 700; line-height: 1.2; color: #000;">
              {{ formatCabin(getFirstSegment()?.cabin?.category) }}
            </p>
          </div>

          <!-- Line Vertical -->
          <div style="width: 1px; background-color: #ccc;"></div>

          <!-- ============ COL 4: Precio (ARS + USD) ============ -->
          <div class="d-flex flex-column justify-content-start align-items-end pt-3 pl-2 pr-1"
               style="width: 22%; min-height: 62px;">
            <p class="mb-0"
               style="font-family: 'Rubik', serif !important; font-size: 12px; font-weight: 500; line-height: 1.2; color: #666;">
              {{ dato.price?.currencyLocal || 'ARS' }}
            </p>
            <p class="mb-1"
               style="font-family: 'Rubik', serif !important; font-size: 17px; font-weight: 700; line-height: 1.2; color: #000;">
              <span *ngIf="dato.status_id !== 5">
                {{ (dato.price?.totalLocal ?? getPrice(dato)) | number:'1.2-2' }}
              </span>
              <span *ngIf="dato.status_id === 5">
                {{ 0 | number:'1.2-2' }}
              </span>
            </p>

            <p class="mb-1"
               style="font-family: 'Rubik', serif !important; font-size: 11px; font-weight: 400; line-height: 1.2; color: #b6b6b6;">
              Imp. Incl.
            </p>

            <div class="d-flex align-items-center" *ngIf="dato.status_id !== 5 && dato.price?.currencyLocal !== dato.currency">
              <p class="mb-0"
                 style="font-family: 'Rubik', serif !important; font-size: 12px; font-weight: 600; line-height: 1.2;">
                <span style="color: #616161">{{ dato.currency }}</span>
                {{ dato.price?.total ?? dato.totalPrice | number:'1.2-2' }}
              </p>
              <div class="info-tool d-flex flex-column position-relative ml-1">
                <img src="../../../assets/icons/admi_01.svg" width="11px" alt="">
                <span class="tooltip-info shadow-md">
                  <div class="d-flex justify-content-center align-items-center px-2 py-1">
                    <p class="mb-0" style="font-size: 14px; color: black">{{ userService.messageProviderAmount }}</p>
                  </div>
                </span>
              </div>
            </div>

            <ng-container *ngIf="dato.status_id !== 5">
              <usb-tooltip-convert-amount
                class="mt-1"
                [clientsSettingAppBooking]="clientSetting"
                [currencyProduct]="currencyAgency?.code"
                [valueProduct]="getPrice(dato)"
              >
              </usb-tooltip-convert-amount>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
